import { Redirect } from "react-router";
import Confirmation from "../pages/Confirmation/Confirmation";
import AdminLogin from "../pages/Admin/AdminLogin/AdminLogin";
import AdminSettings from "../pages/Admin/AdminSettings/AdminSettings";
import Maintenance from "../pages/Maintenance/Maintenance";
import Home from "../pages/Home/Home";

export interface routeInterface {
  name: string;
  path: string;
  component: () => JSX.Element;
}

export const ROUTES = {
  home: {
    name: "Home",
    path: "/home",
    component: () => <Home />,
  },
  maintenance: {
    name: "Maintenance",
    path: "/maintenance",
    component: () => <Maintenance />,
  },
  confirmation: {
    name: "Confirmation",
    path: "/confirmation",
    component: () => <Confirmation />,
  },
  adminLogin: {
    name: "Admin Login",
    path: "/admin/login",
    component: () => <AdminLogin />,
  },
  adminSettings: {
    name: "Admin Settings",
    path: "/admin/settings",
    component: () => <AdminSettings />,
  },
  all: {
    name: "All",
    path: "*",
    component: () => <Redirect to="/home" />,
  },
};
